<script setup lang="ts">
defineProps<{
    compact?: boolean
}>()

const terms = [
    {
        label: 'Stok fisik',
        class: 'text-gray-800',
        description: 'Barang yang benar-benar ada di gudang. Berkurang saat pengiriman pertama pesanan dicatat.',
    },
    {
        label: 'Reserved',
        class: 'text-amber-600',
        description: 'Sudah dipesan di Pesanan Kasir tapi belum dikirim. Barangnya masih di gudang, tapi sudah "dipegang" pesanan itu.',
    },
    {
        label: 'Tersedia',
        class: 'text-emerald-600',
        description: 'Stok fisik dikurangi reserved. Inilah jumlah yang masih bisa dipesan atau ditransfer.',
    },
]
</script>

<template>
    <dl
        class="grid gap-3 text-xs text-gray-600"
        :class="compact ? '' : 'rounded-lg border border-gray-200 bg-gray-50 p-3 sm:grid-cols-3'"
    >
        <div v-for="term in terms" :key="term.label">
            <dt class="font-semibold" :class="term.class">{{ term.label }}</dt>
            <dd>{{ term.description }}</dd>
        </div>
        <div v-if="!compact" class="text-gray-400 sm:col-span-3">
            Contoh: stok fisik 1.000, ada pesanan 800 yang belum dikirim → reserved 800, tersedia 200.
        </div>
        <div :class="compact ? '' : 'sm:col-span-3'">
            <a
                :href="route('guide.public', 'stok')"
                target="_blank"
                rel="noopener"
                class="font-medium text-indigo-600 underline"
                v-tooltip="'Aturan lengkap stok: mengisi, memesan, mengirim, dan transfer'"
            >Baca panduan fitur stok</a>
        </div>
    </dl>
</template>
